import type { ExtendedCommunityChannelMessage } from '../../types/ExtendedCommunityChannelMessage';

/**
 * Resolve a channel message author's display name: "First Last", else the
 * username, else "Unknown". Single source of truth shared by the message
 * bubble, the author user card, and the kebab menu's block confirmation.
 */
export function formatChannelAuthorName(
  profile: ExtendedCommunityChannelMessage['profile'],
): string {
  const first = profile.firstName?.trim() ?? '';
  const last = profile.lastName?.trim() ?? '';
  const composed = `${first} ${last}`.trim();
  if (composed) return composed;
  if (profile.username) return profile.username;
  return 'Unknown';
}
